import { createFileRoute } from '@tanstack/react-router';
import { AdminLayout } from '@/features/admin';

/** Organisation administration: a left navigation around the admin pages. */
export const Route = createFileRoute('/_auth/o/$orgId/admin')({
  component: AdminLayout,
});
